export default __webpack_public_path__ + "static/1-f5c360ccd1fe8738aa3f8a610f68186e.jpg";